<style scoped>
    .confirm-message {
        text-align: center;
    }
</style>

<template>
<ValidationObserver ref="observer" v-slot="{ invalid }">
    <v-dialog v-model="handleDialog" width="1000" class="common-dialog">
        <v-card color="#F4FEFB">
            <v-card-title class="justify-center text-h5"><slot name="message"></slot></v-card-title>
                <v-card-text
                    class="common-dialog-message"
                >
                <v-container>
                    <v-row>
                        <v-col cols="12" xl="3">
                            <badge-component tile content="必　須" color="red">
                                <label-component>企業名</label-component>
                            </badge-component>
                        </v-col>
                        <v-col cols="12" xl="7">
                            <ValidationProvider rules="" v-slot="{ errors }">
                                <v-text-field outlined clearable v-disabled-icon-focus v-model="alertName" :error-messages="errors" background-color="white"></v-text-field>
                            </ValidationProvider>
                        </v-col>
                        <v-col cols="12" xl="3">
                            <badge-component tile content="任　意">
                                <label-component>備考欄</label-component>
                            </badge-component>
                        </v-col>
                        <v-col cols="12" xl="7">
                            <ValidationProvider rules="max:255" v-slot="{ errors }">
                                <v-textarea auto-grow outlined clearable v-disabled-icon-focus rows="2" v-model="alertRemarks" :error-messages="errors" background-color="white"></v-textarea>
                            </ValidationProvider>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
            
            <v-divider></v-divider>
            
            <v-card-actions class="justify-center grey lighten-4 pb-6">
                <v-btn min-width="150px" class="white--text" color="red" large @click="pushOk" :disabled="invalid">
                    <slot name="ok-btn"></slot>
                </v-btn>
                <v-btn min-width="150px" class="white--text" color="blue-grey lighten-1" large @click="handleDialog = false">
                    <slot name="cancel-btn"></slot>
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</ValidationObserver>
</template>

<script>
export default {
    data() {
        return {
            alertItem: this.item, // 子で親のインスタンスを更新するので、一度変数に移す（オブジェクトだが大丈夫か？）
        };
    },
    props: {
        item: {
            id: Number,
            company_name: String,
            remarks: String,
        },
        // ダイアログの開閉
        detailDialog: Boolean,
    },
    computed: {
        handleDialog: {
            get() {
                return this.detailDialog;
            },
            set(value) {
                // 親コンポーネントへの通知
                this.$emit('update:detailDialog', value);
            }
        },
        // オブジェクトの場合はプロパティをバインド（ v-model="alertItem.memo"等）してもリアクティブにならないのでgetter setterを定義してバインドが必要。
        alertName: {
            get() {
                return this.alertItem.company_name;
            },
            set(value) {
                this.alertItem.company_name = value;
            }
        },
        alertRemarks: {
            get() {
                return this.alertItem.remarks;
            },
            set(value) {
                this.alertItem.remarks = value;
            }
        },
    },
    methods: {
        // 更新
        pushOk: function() {
            axios.post('/documents/update-contract-destination-companies/' + this.alertItem.id, {
                company_name: this.alertName,
                remarks: this.alertRemarks,
            }).then(res => {
                // 親コンポーネントへの通知
                if (res.data.success) {
                    this.$emit("success", res.data.message);
                    this.handleDialog = false;
                } else {
                    this.$emit("error", res.data.message);
                }
            }).catch(res => {
              // console.log(res);
                this.success = false;
                this.message = "処理に失敗しました";
            }).finally(() => {
            });
        },
    },
};
</script>